import { render, staticRenderFns } from "./Postcard.vue?vue&type=template&id=732bb785&scoped=true&"
import script from "./Postcard.vue?vue&type=script&lang=js&"
export * from "./Postcard.vue?vue&type=script&lang=js&"
import style0 from "./Postcard.vue?vue&type=style&index=0&id=732bb785&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bb785",
  null
  
)

export default component.exports